import Letter from 'components/animations/Letter';
import Highlighter from 'components/animations/Highlighter';
import FromDirection from 'components/animations/FromDirection';
import Reveal from 'components/animations/Reveal';
import FadeIn from 'components/animations/FadeIn';
import StaggerChildren from 'components/animations/StaggerChildren';

const Animated = { Letter, Highlighter, FromDirection, Reveal, FadeIn, StaggerChildren };

export default Animated;
